module.exports = __webpack_public_path__ + "img/emoji_76.1e54b2d2.png";